import type { NotificationType } from "@/redux/notification/notificationTypes";

export const notificationReducer = {
  resetNotificationError: (state: NotificationType) => {
    state.error = null;
  },
  resetNotificationSuccess: (state: NotificationType) => {
    state.success = null;
  },
  resetNotificationStatusCode: (state: NotificationType) => {
    state.statusCode = null;
  },
  resetScheduleNotificationList: (state: NotificationType) => {
    state.scheduleNotificationList = [];
  },
  resetScheduleNotificationCount: (state: NotificationType) => {
    state.scheduleNotificationCount = 0;
    state.attendence = null;
    // state.notificationCount = 0;
  },
  resetScheduleNotificationListCount: (state: NotificationType) => {
    state.scheduleNotificationListCount = 0;
  },
  setNotificationCount: (state: NotificationType, { payload }: any) => {
    state.notificationCount = payload.count;
  },
  resetNotificationCount: (state: NotificationType) => {
    state.notificationCount = 0;
  },
  setAttendence: (state: NotificationType, { payload }: any) => {
    state.attendence = payload.attendence;
  },
};
